<template>
  <div class="text-caption d-flex gap-1">
    <v-tooltip v-for="({ icon, color, label, value }, index) in getItemStatusInfo(item)" :key="index" top>
      <template #activator="{ on, attrs }">
        <span v-bind="attrs" v-on="on" class="d-flex">
          <v-icon size="16" :color="color" class="mr-1">{{ icon }}</v-icon>
          {{ value }}
        </span>
      </template>
      {{ label }}
    </v-tooltip>
  </div>
</template>

<script>
import { showsNegligenceCount } from '../negligenceFilter'

export default {
  props: {
    item: {
      type: Object,
    },
  },

  methods: {
    getItemStatusInfo(item) {
      const statusInfo = [
        {
          icon: 'mdi-timer-sand',
          color: 'orange',
          label: this.$t('dispute.item.status.PENDING'),
          value: item.pendingItemsQuantity,
        },
        {
          icon: 'mdi-check-circle',
          color: 'green',
          label: this.$t('dispute.item.status.APPROVED'),
          value: item.approvedItemsQuantity,
        },
        {
          icon: 'mdi-close-circle',
          color: 'red',
          label: this.$t('dispute.item.status.REJECTED'),
          value: item.rejectedItemsQuantity,
        },
      ]

      if (showsNegligenceCount(item, this.isAdmin)) {
        statusInfo.push({
          icon: 'mdi-alert-circle',
          color: 'deep-orange',
          label: this.$t('dispute.item.negligence'),
          value: item.negligenceItemsQuantity ?? 0,
        })
      }

      return statusInfo
    },
  },

  computed: {
    isAdmin() {
      return (localStorage.getItem('access_roles') || '').split(',').includes('ROLE_ADMIN')
    },
  },

  data() {
    return {
      disputeItemStatus: ['PENDING', 'APPROVED', 'REJECTED']
    }
  },
}
</script>
